import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { foodTitle, foodList0, shopInFood0, foodList1, shopInFood1, foodListAd, promoteInFood },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="170175" type="struct" title="美食标题" groupName="美食" content={foodTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="195867"
                    type="recommend"
                    title="美食列表1"
                    groupName="美食"
                    content={foodList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="225751"
                    type="recommend"
                    title="美食区电商1"
                    groupName="美食"
                    content={shopInFood0}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225750"
                    type="recommend"
                    title="美食列表2"
                    groupName="美食"
                    content={foodList1}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225752"
                    type="recommend"
                    title="美食区电商2"
                    groupName="美食"
                    content={shopInFood1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={foodListAd} />
                </Chip>
                {promoteInFood && (
                    <Chip id="200152" type="struct" title="铺底推广" groupName="美食" content={promoteInFood}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
